import { localStorage, utils } from '@/util/index';
import moment from 'moment';

import _this from '../main';
import Events from './Events';
import Rest from './Rest';

const Profiles = {
  // partnerLogin: (shareId, isRefresh = false) => {
  //   if ((_this.globalData.token && !isRefresh) || !_this.globalData.appId || !_this.globalData.openId) {
  //     return Promise.resolve();
  //   }
  //
  //   const url = '/mini-campaign/wanke/partner/login';
  //   const params = {
  //     appId: _this.globalData.appId,
  //     openId: _this.globalData.openId,
  //   };
  //   if (shareId) {
  //     params.shareId = shareId;
  //   }
  //
  //   return Rest.post(url, params).then((data) => {
  //     _this.globalData.token = data.token;
  //     _this.globalData.user = data || {};
  //     return !data.nickname;
  //   });
  // },
  login: (shareId, isRefresh = false) => {
    if ((_this.globalData.token && !isRefresh) || !_this.globalData.appId || !_this.globalData.openId) {
      return Promise.resolve();
    }

    const url = '/mini-campaign/wanke/login';
    const params = {
      appId: _this.globalData.appId,
      openId: _this.globalData.openId,
    };
    if (shareId) {
      params.shareId = shareId;
    }

    return Rest.post(url, params).then(({ token, user }) => {
      if (user) {
        if (user.vipExpiredAt) {
          user.isVip = user.vipExpiredAt && moment(user.vipExpiredAt).isAfter(moment(), 'day');
          user.expiredDays = moment(user.vipExpiredAt).diff(moment(), 'day');
        }
        user.channel = user.channel || 'nature'
        user.level = user.level || 0
      }

      _this.globalData.token = token;
      _this.globalData.user = user || {};
      return !user;
    });
  },

  partnerLogin: (isAdmin) => {
    const url = `/dushu/wanke/${isAdmin ? 'statistics' : 'partner'}/login`;
    const params = {
      appId: _this.globalData.appId,
      openId: _this.globalData.openId,
    };
    const { provider } = utils.formatQueryString(window.location.search);
    const preProvider = localStorage.get('preProvider');
    if (provider) {
      params.providerName = provider;
    } else if (preProvider) {
      params.providerName = preProvider;
    }

    return Rest.post(url, params).then(({ token, inviteKey, unlockKey, avatar, nickname, providerId, settings, providers }) => {

      Events.slsEventReport('partner_login', { index: providerId });
      if (token) {
        _this.globalData.token = token;
      }
      _this.globalData.inviteKey = inviteKey;
      _this.globalData.unlockKey = unlockKey;
      _this.globalData.user = { nickname, avatar };
      _this.globalData.settings = settings;
      if (!isAdmin && providers && providers.length > 1) {
        _this.globalData.providers = providers.map((item) => {
          return {
            ...item,
            active: item.id === providerId,
          };
        });
      }
      return !!inviteKey;
    });
  },
};

export default Profiles;
